import { TCreateInformationReqDto } from "@/api/services/admin/information/dtos/create-information.dto";
import { TGetInformationDto } from "@/api/services/admin/information/dtos/get-infomation.dto";
import { TUpdateInformationReqDto } from "@/api/services/admin/information/dtos/update-information.dto";
import { DATE_FORMAT_FOR_API } from "@/constants/datetime";
import { TInformationForm } from "@/features/information/types/informationForm";
import { dayjs } from "@/utils/dayjs";

export const convertInformationFormToCreateReq = (data: TInformationForm, isDraft: boolean): TCreateInformationReqDto => {
  return {
    type: data.type ?? null,
    startDate: data.enableStartDate ? dayjs(data.startDate).format(DATE_FORMAT_FOR_API) : null,
    endDate: data.enableEndDate ? dayjs(data.endDate).format(DATE_FORMAT_FOR_API) : null,
    title: data.title ?? null,
    content: data.content ?? null,
    isDraft,
    file: data.file as unknown as File,
    filePath: data.filePath,
  };
};

export const convertInformationFormToUpdateReq = (data: TInformationForm, isDraft: boolean): TUpdateInformationReqDto => {
  return {
    type: data.type ?? null,
    startDate: data.enableStartDate ? dayjs(data.startDate).format(DATE_FORMAT_FOR_API) : null,
    endDate: data.enableEndDate ? dayjs(data.endDate).format(DATE_FORMAT_FOR_API) : null,
    title: data.title ?? null,
    content: data.content ?? null,
    isDraft,
    file: data.file as unknown as File,
    filePath: data.filePath,
  };
};

export const convertInformationDetailToForm = (data: TGetInformationDto): TInformationForm => {
  return {
    content: data.content || "",
    enableStartDate: !!data.startDate,
    startDate: data.startDate ? dayjs(data.startDate) : null,
    enableEndDate: !!data.endDate,
    endDate: data.endDate ? dayjs(data.endDate) : null,
    title: data.title || "",
    type: data.type || "",
    filePath: data.filePath ?? null,
    isDraft: data.isDraft ?? false,
    emailBroadCastHistories: data.emailBroadCastHistories ?? [],
  };
};
